document.addEventListener("DOMContentLoaded", function () {
  const tabsWrap = document.querySelector("[data-ref-tabs]");
  const grid = document.querySelector("[data-ref-grid]");
  if (!tabsWrap || !grid) return;

  const buttons = Array.from(tabsWrap.querySelectorAll("[data-filter]"));
  const cards = Array.from(grid.querySelectorAll("[data-terms]"));

  function setActive(btn) {
    buttons.forEach(b => b.classList.toggle("is-active", b === btn));
  }

  function applyFilter(filter) {
    cards.forEach(card => {
      const terms = (card.getAttribute("data-terms") || "").split(" ");
      const show = (filter === "all") || terms.includes(filter);
      card.style.display = show ? "" : "none";
    });
  }

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const filter = btn.getAttribute("data-filter");
      setActive(btn);
      applyFilter(filter);
    });
  });

  // default
  applyFilter("all");
});

document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".b-duten");
  if (!root) return;

  const svg = root.querySelector(".js-svg");
  if (!svg) return;

  const outlineText = svg.querySelector(".b__text");
  const maskText = svg.querySelector(".b__maskText") || svg.querySelector("mask text");
  const trailGroup = svg.querySelector(".js-trail");

  if (!outlineText || !maskText || !trailGroup) return;

  const NS = "http://www.w3.org/2000/svg";

  // ===== TUNING =====
  const SEGMENTS = 28;
  const HEAD_R = 52;
  const TAIL_R = 10;
  const FOLLOW = 0.22;

  const HOVER_PAD = 18;
  const BOUNDS_PAD = 20; // manji pad da ostane u slovima

  const HOVER_EASE = 0.18;

  // idle (random) – smireno
  const IDLE_EASE = 0.06;
  const IDLE_MAX_SPEED = 22; // sporije
  const IDLE_TURN_RATE = 0.35;
  const IDLE_DRIFT = 10;

  const OPACITY_IDLE = 0.45;
  const OPACITY_HOVER = 1.0;

  function clamp(v, a, b) {
    return Math.max(a, Math.min(b, v));
  }

  function clientToViewBox(clientX, clientY) {
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;

    const m = svg.getScreenCTM();
    if (!m) return {
      x: 960,
      y: 230
    };

    const p = pt.matrixTransform(m.inverse());
    return {
      x: p.x,
      y: p.y
    };
  }

  function isOverText(p) {
    const box = outlineText.getBBox();
    return (
      p.x >= box.x - HOVER_PAD &&
      p.x <= box.x + box.width + HOVER_PAD &&
      p.y >= box.y - HOVER_PAD &&
      p.y <= box.y + box.height + HOVER_PAD
    );
  }

  // ✅ bounds stabilizacija: refresh tek kad font/layout bude spreman
  let bounds = {
    minX: 0,
    maxX: 1920,
    minY: 0,
    maxY: 461
  };

  function safeBBox(el) {
    try {
      return el.getBBox();
    } catch (e) {
      return null;
    }
  }

  function computeBounds() {
    const b = safeBBox(maskText) || safeBBox(outlineText);
    if (!b || !isFinite(b.x) || !isFinite(b.width) || b.width <= 0) return false;

    bounds = {
      minX: b.x + BOUNDS_PAD,
      maxX: b.x + b.width - BOUNDS_PAD,
      minY: b.y + BOUNDS_PAD,
      maxY: b.y + b.height - BOUNDS_PAD
    };

    // safety: ako pad previše “pojede” bbox
    if (bounds.maxX <= bounds.minX) {
      bounds.minX = b.x;
      bounds.maxX = b.x + b.width;
    }
    if (bounds.maxY <= bounds.minY) {
      bounds.minY = b.y;
      bounds.maxY = b.y + b.height;
    }

    return true;
  }

  // pokušaj odmah, pa posle frame-a, pa posle load-a
  computeBounds();
  requestAnimationFrame(() => computeBounds());
  window.addEventListener("load", () => computeBounds());

  // i na resize
  new ResizeObserver(() => {
    computeBounds();
  }).observe(root);

  // ===== create segments =====
  trailGroup.innerHTML = "";
  const nodes = [];

  for (let i = 0; i < SEGMENTS; i++) {
    const t = i / (SEGMENTS - 1);
    const r = HEAD_R * (1 - t) + TAIL_R * t;

    const c = document.createElementNS(NS, "circle");
    c.setAttribute("r", r.toFixed(2));
    c.setAttribute("cx", "960");
    c.setAttribute("cy", "230");
    trailGroup.appendChild(c);

    nodes.push({
      el: c,
      x: 960,
      y: 230
    });
  }

  // ===== state =====
  let hovering = false;

  let x = 960,
    y = 230;
  let tx = 960,
    ty = 230;

  let idleVX = 0,
    idleVY = 0;
  let idleAngle = Math.random() * Math.PI * 2;

  function setOpacity(v) {
    trailGroup.setAttribute("opacity", String(v));
  }

  // ✅ init: centar bbox-a teksta
  function initInsideText() {
    if (!computeBounds()) return;

    const cx0 = (bounds.minX + bounds.maxX) / 2;
    const cy0 = (bounds.minY + bounds.maxY) / 2;

    x = tx = cx0;
    y = ty = cy0;

    for (let i = 0; i < SEGMENTS; i++) {
      nodes[i].x = x;
      nodes[i].y = y;
      nodes[i].el.setAttribute("cx", x.toFixed(2));
      nodes[i].el.setAttribute("cy", y.toFixed(2));
    }
  }

  initInsideText();
  requestAnimationFrame(() => initInsideText());

  setOpacity(OPACITY_IDLE);

  // ===== animation loop =====
  let last = performance.now();

  function render(now) {
    const dt = Math.min(0.033, (now - last) / 1000);
    last = now;

    if (hovering) {
      setOpacity(OPACITY_HOVER);

      x += (tx - x) * HOVER_EASE;
      y += (ty - y) * HOVER_EASE;
    } else {
      setOpacity(OPACITY_IDLE);

      idleAngle += (Math.random() - 0.5) * IDLE_TURN_RATE * dt;

      idleVX += Math.cos(idleAngle) * IDLE_DRIFT * dt;
      idleVY += Math.sin(idleAngle) * IDLE_DRIFT * dt;

      const sp = Math.hypot(idleVX, idleVY);
      if (sp > IDLE_MAX_SPEED) {
        const s = IDLE_MAX_SPEED / sp;
        idleVX *= s;
        idleVY *= s;
      }

      // target ide kroz bounds
      tx = clamp(tx + idleVX, bounds.minX, bounds.maxX);
      ty = clamp(ty + idleVY, bounds.minY, bounds.maxY);

      // bounce
      if (tx <= bounds.minX + 0.5 || tx >= bounds.maxX - 0.5) idleVX *= -0.85;
      if (ty <= bounds.minY + 0.5 || ty >= bounds.maxY - 0.5) idleVY *= -0.85;

      x += (tx - x) * IDLE_EASE;
      y += (ty - y) * IDLE_EASE;
    }

    // head
    nodes[0].x = x;
    nodes[0].y = y;

    // trail follow
    for (let i = 1; i < SEGMENTS; i++) {
      const prev = nodes[i - 1];
      const cur = nodes[i];
      cur.x += (prev.x - cur.x) * FOLLOW;
      cur.y += (prev.y - cur.y) * FOLLOW;
    }

    // paint
    for (let i = 0; i < SEGMENTS; i++) {
      const n = nodes[i];
      n.el.setAttribute("cx", n.x.toFixed(2));
      n.el.setAttribute("cy", n.y.toFixed(2));
    }

    requestAnimationFrame(render);
  }

  requestAnimationFrame(render);

  // ===== mouse =====
  window.addEventListener("mousemove", (e) => {
    const p = clientToViewBox(e.clientX, e.clientY);
    hovering = isOverText(p);

    if (hovering) {
      if (!computeBounds()) return; // za svaki slučaj
      tx = clamp(p.x, bounds.minX, bounds.maxX);
      ty = clamp(p.y, bounds.minY, bounds.maxY);
    }
  }, {
    passive: true
  });

  window.addEventListener("mouseleave", () => {
    hovering = false;
  }, {
    passive: true
  });
});


(function ($) {
  $(function () {


     var POPUP_ID = 'custom-kitchen-popup';
    var STORAGE_KEY = 'kitchenPopupHiddenUntil';
    var SHOW_DELAY_MS = 3000;
    var HIDE_DAYS = 7;

    function $popup() {
      return $('#' + POPUP_ID);
    }

    function nowTs() {
      return Date.now();
    }

    function daysToMs(days) {
      return days * 24 * 60 * 60 * 1000;
    }

    function getHiddenUntil() {
      var v = localStorage.getItem(STORAGE_KEY);
      if (!v) return 0;
      var ts = parseInt(v, 10);
      return isNaN(ts) ? 0 : ts;
    }

    function setHiddenForDays(days) {
      var until = nowTs() + daysToMs(days);
      localStorage.setItem(STORAGE_KEY, String(until));
    }

    function shouldShowPopup() {
      return nowTs() > getHiddenUntil();
    }

    function openPopup() {
      var $el = $popup();
      if (!$el.length) return;
      $el.css('display', 'flex').addClass('is-open');
    }

    // setCooldown = true => upis u localStorage
    function closePopup(setCooldown) {
      var $el = $popup();
      if (!$el.length) return;

      $el.css('display', 'none').removeClass('is-open');

      if (setCooldown) {
        setHiddenForDays(HIDE_DAYS);
      }
    }

    // Inline onclick koristi ovo: closeKitchenPopup() => upisuje cooldown
    window.closeKitchenPopup = function () {
      closePopup(true);
    };

    // 1) show posle 3s, samo ako nije cooldown
    if (shouldShowPopup()) {
      setTimeout(function () {
        if (shouldShowPopup()) {
          openPopup();
        }
      }, SHOW_DELAY_MS);
    }

    // 2) X klik => zatvori + upiši 7 dana
    $(document).on('click', '#' + POPUP_ID + ' .close-btn', function (e) {
      e.preventDefault();
      closePopup(true);
    });

    // 3) outside klik (na overlay) => samo zatvori, BEZ localStorage
    $(document).on('click', '#' + POPUP_ID, function (e) {
      if (e.target === this) {
        closePopup(false);
      }
    });

    // 4) ESC (opciono) => samo zatvori, BEZ localStorage
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        var $el = $popup();
        if ($el.length && ($el.is(':visible') || $el.hasClass('is-open'))) {
          closePopup(false);
        }
      }
    });



    const $slider = $('.dd-ref-slider');

    if ($slider.length) {
      $slider.owlCarousel({
        items: 2.5,
        margin: 30,
        loop: true,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 4500,
        autoplayHoverPause: true,
        smartSpeed: 600,
        responsive: {
          0: {
            items: 1,
            margin: 18
          },
          768: {
            items: 2,
            margin: 24
          },
          1200: {
            items: 2.5,
            margin: 30
          }
        }
      });
    }

    // AOS
    AOS.init();


    // OPEN / CLOSE MENU
    $('.nav-button').on('click', function (e) {
      e.preventDefault();

      var isActive = $(this).hasClass('active');

      if (isActive) {
        // close
        $(this).removeClass('active');
        $('.navigation-floating').removeClass('opened');
        $('.overlay-black').removeClass('active');
      } else {
        // open
        $(this).addClass('active');
        $('.navigation-floating').addClass('opened');
        $('.overlay-black').addClass('active');
      }
    });

    // CLOSE ICON
    $(document).on('click', '.nav-floating-btn', function () {
      $('.navigation-floating').removeClass('opened');
      $('.nav-button').removeClass('active');
      $('.overlay-black').removeClass('active');

      // zatvori i sve dropdown-e
      $('#secondary-menu .menu-item-has-children').removeClass('is-sub-open active');

      $('.navigation-bottom.mobile').toggleClass('hide');
    });

    // CLICK OUTSIDE => CLOSE
    $(document).on('mouseup', function (e) {
      var $floating = $(".navigation-floating.opened");

      if (!$floating.length) return;

      if (!$floating.is(e.target) && $floating.has(e.target).length === 0) {
        $('.navigation-floating').removeClass('opened');
        $('.overlay-black').removeClass('active');
        $('.nav-button').removeClass('active');

        // zatvori dropdown-e
        $('#secondary-menu .menu-item-has-children').removeClass('is-sub-open active');
      }
    });

    // OVERLAY CLICK => CLOSE
    $(document).on('click', '.overlay-black.active', function () {
      $('.navigation-floating').removeClass('opened');
      $('.overlay-black').removeClass('active');
      $('.nav-button').removeClass('active');

      $('#secondary-menu .menu-item-has-children').removeClass('is-sub-open active');
    });


    /* =========================
       DROPDOWN (submenu)
       ========================= */

    // 1) ubaci toggle dugme (strelicu) za sve parent iteme
    // radi i kad WP menja meni, ali ti je dovoljno na ready
    $('#secondary-menu li.menu-item-has-children').each(function () {
      var $li = $(this);

      // ako već postoji toggle, preskoči
      if ($li.children('.submenu-toggle').length) return;

      // ubaci button posle <a>
      $li.children('a').after(
        '<button class="submenu-toggle" type="button" aria-label="Open submenu" aria-expanded="false">' +
        '<i class="icon-angle-down" aria-hidden="true"></i>' +
        '</button>'
      );

      // accessibility: da parent a sa href="#" ne skroluje gore
      var $a = $li.children('a');
      if ($a.attr('href') === '#') {
        $a.attr('role', 'button');
      }
    });

    // 2) klik na strelicu => toggle sub-menu
    $(document).on('click', '#secondary-menu .submenu-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $li = $(this).closest('li.menu-item-has-children');

      // zatvori ostale (ako želiš da samo jedan bude otvoren)
      $li.siblings('.menu-item-has-children').removeClass('is-sub-open active')
        .find('.submenu-toggle').attr('aria-expanded', 'false');

      // toggle trenutni
      $li.toggleClass('is-sub-open active');

      var expanded = $li.hasClass('is-sub-open');
      $(this).attr('aria-expanded', expanded ? 'true' : 'false');
    });

    // 3) klik na parent link:
    // - ako je href "#", tretiraj kao toggle
    // - ako je pravi link, pusti da navigira normalno
    $(document).on('click', '#secondary-menu li.menu-item-has-children > a', function (e) {
      var href = $(this).attr('href');
      if (href === '#') {
        e.preventDefault();
        $(this).siblings('.submenu-toggle').trigger('click');
      }
    });


    /*
     * Navbar fixed 
     */
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 1) {
        $('.site-header').addClass('navbar-fixed-top fadeInDown animated');
      } else {
        $('.site-header').removeClass('navbar-fixed-top fadeInDown animated');
      }
    });

    /*
     * Toggle burger menu on mobile
     */
    $('.menu-btn-burger').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $(".mobile-menu").toggleClass('sliding-open');
    });

    /* 
     * Owl carousel
     */
    $('.owl-room-card').owlCarousel({
      margin: 40,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      nav: true,
      dots: false,
      animateOut: 'fadeOut',
      navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
      // navContainer: '#customNav',
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
          margin: 0,
        },
        1200: {
          items: 3,
        }
      }
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function (e) {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });



    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });

    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });



    /*
     * Mmenu light 
     */
    var menu = new MmenuLight(
      document.querySelector('#my-menu'),
      'all'
    );
    if (menu) {
      var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        title: 'Menü'
      });

      var drawer = menu.offcanvas({
        position: 'right'
      });

      //  Open the menu.
      document.querySelector('#nav-icon')
        .addEventListener('click', evnt => {
          evnt.preventDefault();
          drawer.open();
        });

      $(".mob-menu-close").click(function () {
        drawer.close();
      });
    }

  });
})(jQuery);